site:
  title: Affiliates System
  lang: en
modals:
  login:
    title: Log in
    submitButton: Log in
    resetLink: Reset you password
    signUpLink: Register
    or: or
  reset:
    title: Forgot your password?
    submitButton: Reset Password
  signUp:
    title: Register
    submitButton: Register
    termsText: I accept the
    termsLink: Affiliate Terms & Conditions
  notVerified:
    title: You have registered successfully.
    text: We will review your application and, if your account is verified, you will be notified via email.
  terms:
    title: AFFILIATE TERMS & CONDITIONS
whyUs:
  title: WHY HEYROLLER?
  subtitle: Simple setup. Clear data. Reliable partnership.
  note: ""
  action:
    text: ""
  list:
    - id: whyus-1
      title: AVAILABLE SUPPORT
      text: Help is there when you need it.
      image: support
    - id: whyus-2
      title: QUALITY GAME SELECTION
      text: A strong base for your traffic.
      image: game
    - id: whyus-3
      title: EASY-TO-READ STATS
      text: Understand your performance at a glance.
      image: stats
    - id: whyus-4
      title: CONSISTENT PAYMENTS
      text: Clear and dependable commission handling.
      image: wallet
commission:
  title: Commission
  subtitle: Our commission model is designed to support both new and experienced affiliates. As your traffic develops, your revenue share can grow alongside it.
  note: "We’re also open to discussing tailored partnership options, with flexible structures based on your traffic and overall approach."
  button: Get Started
  variant: circular
  modifier: card--primary
  list:
    - id: 1779317345311_5yw5rt2mw
      title: "2"
      image: wallet
      list: []
      level: "1"
      percentage: 2
      range: "123"
testimonials:
  title: Testimonials
  subtitle: ""
  note: ""
  action:
    text: ""
  list:
    - id: testimonial-1
      text: Working with HeyRoller has been straightforward from the beginning. Communication is clear, reporting is easy to follow, and the team is responsive when something comes up.
      link:
        text: uudet-pikakasinot-fi.com
        href: https://uudet-pikakasinot-fi.com
    - id: testimonial-2
      text: What stands out is how reliable everything feels. The setup is simple, the data is clear, and support is there when you need it.
      link:
        text: oncasitown.com
        href: https://oncasitown.com
    - id: testimonial-3
      text: It’s a partnership that runs smoothly day to day. Things are handled clearly, which makes it easier to focus on growing traffic without overcomplicating the process.
      link:
        text: www.askgamblers.com
        href: https://www.askgamblers.com
faq:
  title: FAQ
  subtitle: ""
  note: ""
  action:
    text: Affiliate Program Terms & Conditions
    modal: terms
  list:
    - id: section-1
      question: What is the HeyRoller Affiliate Program?
      answer: It’s a partnership for affiliates who want to promote HeyRoller and earn commission based on the players they refer.
      type: text
    - id: section-2
      question: How do I become a partner?
      answer: You can get started by reaching out through the contact options on this page. Our team will guide you through the next steps.
      type: text
    - id: section-3
      question: What affiliate software do you use?
      answer: You’ll have access to a tracking platform where you can follow your performance, traffic, and results in a clear and practical way.
      type: text
    - id: section-4
      question: How do I get in touch?
      answer: You can contact our affiliate team directly using the channels available on this page.
      type: text
    - id: section-5
      question: How much does it cost to join?
      answer: Joining the HeyRoller Affiliate Program is free.
      type: text
    - id: section-6
      question: How much can I earn?
      answer: It depends on the volume and quality of your traffic. As your referred players grow, your earnings will grow with them.
      type: text
contacts:
  title: Contacts
  subtitle: ""
  note: ""
  action:
    text: ""
  list:
    - id: contact-1
      type: telegram
      href: 'https://t.me/jarvisupport'
      text: '@jarvisupport'
      icon: telegram
      alt: Telegram icon
hero:
  title: HeyRoller Affiliate Program
  subtitle: Join the
  text: Partner with HeyRoller and promote a brand built for consistency and long-term growth. We offer a reliable setup, clear reporting, and a team that’s available when you need support. Everything is designed to make collaboration straightforward, so you can focus on building and scaling your traffic with confidence.
  action:
    text: ""
  image: banner
  imageMobile: banner-mob
footer:
  copyright: © 2026 HeyRoller Partners | All rights reserved
settings:
  showMenu: true
  showHero: true
  showWhyUs: true
  showCommission: true
  showTestimonials: true
  showFaq: true
  showContacts: true
  logoPath: /logo.webp
  logoSmallPath: /logo-small.webp
metadata:
  title: Affiliates system
  description: Affiliates system
  keywords: casino affiliate, affiliate program, revenue share, CPA, hybrid deals, gambling affiliate
  author: SuperPartners
  robots: index, follow
